<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
    data() {
        return {
            disableOnSubmit : false,
            clubAdmin : false,
            coachAdmin: false,
            scorerAdmin: false,
            umpireAdmin: false,
        }
    },

    props: [],

    mixins: [validateAndSubmit, validationClass],

    computed: {        
        hasClub : function() {
            return this.clubAdmin == 1 ? true : false;
        },
        hasRole: function() {

            return this.clubAdmin == 1
                || this.coachAdmin == 1
                || this.scorerAdmin == 1
                || this.umpireAdmin == 1
                 ? true : false;
        },

        roleErrors: function() {

            return this.errors.has('role-register-form.role_clubadmin')
                || this.errors.has('role-register-form.role_coach')
                || this.errors.has('role-register-form.role_scorer')
                || this.errors.has('role-register-form.role_umpire')
                 ? true : false;
        },        

        roleMessage: function () {
            var str = '';

            if (this.errors.has('role-register-form.role_clubadmin')
                || this.errors.has('role-register-form.role_coach')
                || this.errors.has('role-register-form.role_scorer')
                || this.errors.has('role-register-form.role_umpire')) {
                    str = 'At least one of role is required.';
                }

            return str;
        }


    },

    created() {

    },

    mounted() {
    },

    watch: {
    },

    methods: {
    },
}
</script>
